import React from 'react';
import './CivilStatusModal.css'; // Import CSS separately for clarity

const CivilStatusModal = ({ isOpen, onClose, status }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 className="modal-title">Access Restricted</h2>
        <p className="modal-message">
          Your account is currently marked as <strong>{status}</strong>.
        </p>
        <p className="modal-subtext">
          Please contact admin support to resolve this issue.
        </p>
        <button className="modal-button" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default CivilStatusModal;
